<template>
  <div class="web-introduce">
    <div class="introduce-img">
      <div>
        <img src="/static/img0.jpg" />
      </div>
    </div>
    <div class="introduce-content">
      <div class="introduce-name">
        <span>{{ name }}</span>
      </div>
      <div class="social-media">
        <el-row>
          <el-col :span="4" :offset="2" align="middle">
            <a @click="$root.replaceURL('wiki')" title="博客">
              <i class="social fa fa-wikipedia-w"></i>
            </a>
          </el-col>
          <el-col :span="4" align="middle">
            <a href="http://git.hidaobao.com" title="gitlab">
              <i class="social fa fa-gitlab"></i>
            </a>
          </el-col>
          <el-col :span="4" align="middle">
            <a href="http://github.com/tice9982" title="gitlab">
              <i class="social fa fa-github"></i>
            </a>
          </el-col>
          <el-col :span="4" align="middle">
            <a href="mailto:39593539@qq.com" title="发邮件给我">
              <i class="social fa fa-envelope"></i>
            </a>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// import '/static/css/font-awesome-4.7.0/css/font-awesome.css'

export default {
  name: 'webaboutme',
  data: function () {
    return {
      name: '谭莹冰 私人定制'
    }
  },
  created () {}
}
</script>

<style>
.web-introduce {
  width: 100%;
  height: 100%;
}

.introduce-img {
  height: 40%;
}

.introduce-img div {
  position: relative;
  width: 84px;
  height: 84px;
  top: 20%;
  transform: translateY(-50%);
  margin: auto;
}

.introduce-img div > img {
  width: 84px;
  height: 84px;
  border-radius: 42px;
}

.introduce-content {
  width: 100%;
  margin: 5% auto;
}

.introduce-name {
  width: 100%;
  height: 50px;
  line-height: 20px;
  text-align: center;
  position: relative;
  top: -5px;
}
.introduce-name span {
  font-size: 1.6em;
}

.introduce-name::after,
.introduce-name::before {
  position: absolute;
  width: 30%;
  height: 1px;
  background: #000;
  content: "";
  top: 10px;
}

.introduce-name::after {
  left: 0;
}

.introduce-name::before {
  right: 0;
}

.social-media {
  margin: auto;
  width: 400px;
}

.social {
  font-size: 32px;
}

.qrCode[data-v] {
  display: none;
  position: absolute;
  width: 92px;
  height: 92px;
  bottom: 42px;
  left: -28px;
  text-align: center;
  background-color: #fff;
}
.wechat .qrCode .triangle-down[data-v] {
  position: absolute;
  bottom: -8px;
  left: 50%;
  margin-left: -6px;
  width: 0;
  height: 0;
  border-top: 10px sodivd #fff;
  border-left: 6px sodivd transparent;
  border-right: 6px sodivd transparent;
}
.wechat:hover .qrCode[data-v] {
  display: indivne;
}
</style>



// WEBPACK FOOTER //
// src/components/webaboutme.vue